import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  replaceInUrl,
} from './index';
import apiEndpoints from './apiEndpoints';

export const getPriceAlertsRequest = (accountUid) =>
  getRequest(replaceInUrl(apiEndpoints.accounts.priceAlerts, { accountUid }));

export const getPriceAlertsByProductRequest = ({ accountUid, productCode }) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.priceAlertsByProduct, {
      accountUid,
      productCode,
    }),
  );

export const getPriceAlertRequest = ({ accountUid, priceAlertUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.getPriceAlert, {
      accountUid,
      priceAlertUid,
    }),
  );

export const patchPriceAlertsRequest = ({
  accountUid,
  ProductCode,
  TargetPrice,
  PriceAtSubmission,
  Phone,
}) =>
  patchRequest(
    replaceInUrl(apiEndpoints.accounts.priceAlerts, { accountUid }),
    { ProductCode, TargetPrice, PriceAtSubmission, Phone },
  );

export const patchPriceAlertRequest = ({
  accountUid,
  priceAlertUid,
  ProductCode,
  TargetPrice,
  PriceAtSubmission,
  Phone,
}) =>
  patchRequest(
    replaceInUrl(apiEndpoints.accounts.patchPriceAlert, {
      accountUid,
      priceAlertUid,
    }),
    { ProductCode, TargetPrice, PriceAtSubmission, Phone },
  );

export const deletePriceAlertRequest = ({
  accountUid,
  priceAlertUid,
  currentPrice,
}) =>
  deleteRequest(
    replaceInUrl(apiEndpoints.accounts.deletePriceAlert, {
      accountUid,
      priceAlertUid,
    }),
    { currentPrice },
  );

export const dismissPriceAlertBadgeRequest = ({ accountUid, productCode }) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.dismissPriceAlertBadge, { accountUid }),
    { ProductCode: productCode },
  );

export const dismissPriceAlertBannerRequest = ({ accountUid, productCode }) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.dismissPriceAlertBanner, {
      accountUid,
    }),
    { ProductCode: productCode },
  );

export const clearExpiredPriceAlertsRequest = ({ accountUid, productCode }) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.clearExpiredPriceAlerts, {
      accountUid,
    }),
    { productCode },
  );

export const setupMockPriceAlertsRequest = (accountUid) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.setupMockPriceAlerts, { accountUid }),
  );

export const postPriceAlertRequest = ({
  accountUid,
  ProductCode,
  TargetPrice,
  PriceAtSubmission,
  Phone,
  Email,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.postPriceAlert, { accountUid }),
    { ProductCode, TargetPrice, PriceAtSubmission, Phone, Email },
  );
